import { gql } from "@apollo/client";

export const listRewards = gql`
  query ListRewards($filter: RewardFilterInput, $page: Int, $size: Int) {
    listRewards(filter: $filter, page: $page, size: $size) {
      first
      last
      self
      total
      items {
        id
        name
      }
    }
  }
`;

export default listRewards;
